var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditUserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 28,
    viewBox: "0 0 41 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 0.5,
    width: 39,
    height: 27,
    rx: 4.5,
    stroke: "#50C878"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0738 7.84496H15.8089C14.3957 7.84496 13.25 8.99059 13.25 10.4038V18.9333C13.25 20.3466 14.3957 21.4922 15.8089 21.4922H24.3387C25.7519 21.4922 26.8976 20.3466 26.8976 18.9333L26.8976 14.6686M17.5149 17.2274L20.6183 16.6021C20.783 16.5689 20.9343 16.4878 21.0531 16.3689L28.0003 9.41806C28.3334 9.0848 28.3332 8.54461 27.9998 8.21164L26.5282 6.74167C26.1949 6.40883 25.655 6.40906 25.322 6.74218L18.3741 13.6937C18.2555 13.8124 18.1745 13.9633 18.1413 14.1277L17.5149 17.2274Z",
    stroke: "#50C878",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditUserIcon);
export default __webpack_public_path__ + "static/media/edit_user_icon.372ad8230151a2c6fa899143f656429e.svg";
export { ForwardRef as ReactComponent };